import { defineStore } from "pinia";
import {
  WEBVIEW_PLATFORM,
  USER_AGENT,
  BROWSER_PLATFORM,
  BROWSER_PLATFORMSRING,
} from "~/config/equipment";

import type { RouteRecordName } from "vue-router";

export const useEquipmentStore = defineStore("equipment", {
  state: (): {
    appConfig: any;
    sm: boolean;
    shareList: any[];
    webappConfig: any;
    title: string;
    forceRefreshPath: RouteRecordName[];
    cacheCloseShareTipV2Time: number | null;
    refreshing: boolean;
    headerHeight: number;
    tabbarHeight: number;
    webviewPlatform: WEBVIEW_PLATFORM;
    browserPlatform: BROWSER_PLATFORM;
    cacheLastUseTime: number | null;
    pcTabbarKey: string | null;
    systemloginConfig: any;
    telegram_bot_name: string;
    google_client_id: string | null;
    facebook_app_id: string | null;
    browserPlatformString: BROWSER_PLATFORMSRING;
    relogin_notice: any;
    expire_notice: any;
    ispcSide: boolean;
    systemloginConfigAll: any;
    mail_domains: any[];
    isShowAndroidHeader: boolean;
    apple_bind_telegram: string | null;
    tgSourceShowName: string | null;
    share_platform: any;
  } => {
    return {
      appConfig: {},
      sm: true,
      shareList: [],
      webappConfig: {},
      title: "",
      forceRefreshPath: [],
      cacheCloseShareTipV2Time: null,
      refreshing: false,
      headerHeight: 0,
      tabbarHeight: 0,
      cacheLastUseTime: null,
      webviewPlatform: WEBVIEW_PLATFORM.NONE,
      browserPlatform: BROWSER_PLATFORM.DEFAULT,
      browserPlatformString: BROWSER_PLATFORMSRING.GOOGLE,
      pcTabbarKey: null,
      systemloginConfig: null,
      telegram_bot_name: "",
      google_client_id: null,
      facebook_app_id: null,
      relogin_notice: {},
      expire_notice: {},
      ispcSide: false,
      systemloginConfigAll: null,
      mail_domains: [],
      isShowAndroidHeader: true,
      apple_bind_telegram: null,
      tgSourceShowName: null,
      share_platform: null,
    };
  },
  actions: {
    async initSystemloginConfig() {
      const res = await api_loginConfigsince(this.browserPlatformString);
      const { code, data } = res.res;
      if (code === 0) {
        this.systemloginConfig = data.render;
        this.systemloginConfigAll = data;
        this.telegram_bot_name = data.telegram_bot_name;
        this.apple_bind_telegram = data.apple_bind_telegram;
        this.google_client_id = data.google_client_id;
        this.facebook_app_id = data.facebook_app_id;
        this.relogin_notice = data.relogin_notice || {};
        this.expire_notice = data.expire_notice || {};
        this.mail_domains = data.mail_domains || [];
      }
    },
    initAppByDevice(userAgent: string) {
      if (!userAgent && import.meta.client) {
        userAgent = window.navigator.userAgent;
      }

      this.setBrowserPlatform(userAgent);
      if (userAgent === USER_AGENT.IOS) {
        this.webviewPlatform = WEBVIEW_PLATFORM.IOS;
      } else if (userAgent === USER_AGENT.ANDROID) {
        this.webviewPlatform = WEBVIEW_PLATFORM.ANDROID;
      } else {
        return WEBVIEW_PLATFORM.NONE;
      }
    },

    setBrowserPlatform(userAgent?: string) {
      if (!userAgent) return;

      if (/FBAN|FBAV/i.test(userAgent)) {
        this.browserPlatform = BROWSER_PLATFORM.FACEBOOK;
        this.browserPlatformString = BROWSER_PLATFORMSRING.FACEBOOK;
      } else if (
        /Safari/i.test(userAgent) &&
        /AppleWebKit/i.test(userAgent) &&
        !/Chrome/i.test(userAgent)
      ) {
        this.browserPlatform = BROWSER_PLATFORM.SAFARI;
        this.browserPlatformString = BROWSER_PLATFORMSRING.SAFARI;
      } else {
        this.browserPlatform = BROWSER_PLATFORM.DEFAULT;
        this.browserPlatformString = BROWSER_PLATFORMSRING.GOOGLE;
      }
    },

    // 判断ios设备
    isIOS(userAgent: string = "") {
      // let reg = /\(i[^;]+;( U;)? CPU.+Mac OS X/
      const reg = /iphone|ipad|ipod/i;
      const u = userAgent || window?.navigator?.userAgent;
      if (reg.test(u)) {
        return true;
      } else {
        return false;
      }
    },

    // 判断android设备
    isAndroid(userAgent: string = "") {
      const reg = /android/i;
      const u = userAgent || window?.navigator?.userAgent;
      if (reg.test(u)) {
        return true;
      } else {
        return false;
      }
    },

    // 判断浏览器
    isBrowser() {
      const u = navigator.userAgent;
      return {
        // 移动终端浏览器版本信息
        trident: u.indexOf("Trident") > -1, // IE内核
        presto: u.indexOf("Presto") > -1, // opera内核
        webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1, // 火狐内核
        mobile:
          !!u.match(/AppleWebKit.*Mobile/i) ||
          !!u.match(
            /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/
          ), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或者uc浏览器
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, // 是否iPad
        webApp: u.indexOf("Safari") === -1, // 是否web应该程序，没有头部与底部
      };
    },

    //about配置参数，只需区别电脑端/安卓/ios
    setAboutBrowserPlatform() {
      if (this.isIOS()) {
        return "ios";
      } else if (this.isAndroid()) {
        return "android";
      } else {
        return "h5";
      }
    },

    //判断是否在电脑端
    isPCPlatform() {
      // const platform = navigator.platform.toLowerCase();
      // return (
      //   platform.indexOf("win") > -1 ||
      //   platform.indexOf("mac") > -1 ||
      //   platform.indexOf("linux") > -1
      // );

      const equipment = useEquipmentStore();

      const isMobile =
        /Mobi|Android/i.test(navigator.userAgent) ||
        equipment.webviewPlatform !== WEBVIEW_PLATFORM.NONE;

      return !isMobile;
    },
    //获取用户设备类型
    getUserDeviceInfo() {
      const userAgent = navigator.userAgent;
      let deviceType = "unknown";
      let os = "unknown";
      let browser = "unknown";

      // 判断设备类型
      if (/mobile/i.test(userAgent)) {
        deviceType = "mobile";
      } else if (/tablet/i.test(userAgent)) {
        deviceType = "tablet";
      } else {
        deviceType = "desktop";
      }

      // 判断操作系统
      if (/Windows/i.test(userAgent)) {
        os = "Windows";
      } else if (/Macintosh/i.test(userAgent)) {
        os = "MacOS";
      } else if (/Linux/i.test(userAgent)) {
        os = "Linux";
      } else if (/Android/i.test(userAgent)) {
        os = "Android";
      } else if (/iOS/i.test(userAgent)) {
        os = "iOS";
      }

      // 判断浏览器
      if (/Chrome/i.test(userAgent)) {
        browser = "Chrome";
      } else if (/Firefox/i.test(userAgent)) {
        browser = "Firefox";
      } else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
        browser = "Safari";
      } else if (/MSIE/i.test(userAgent) || /Trident/i.test(userAgent)) {
        browser = "Internet Explorer";
      } else if (/Edge/i.test(userAgent)) {
        browser = "Edge";
      }

      return {
        deviceType,
        os,
        browser,
      };
    },
  },

  persist: [
    {
      pick: ["cacheCloseShareTipV2Time", "cacheLastUseTime"],
      storage: piniaPluginPersistedstate.localStorage(),
    },
  ],
});
